import type { ApplicationSession } from "@services/applicationSessions.service";

const getFullYear = (year: number): number => (year.toString().length === 2 ? Number(`20${year}`) : year);

/**
 * Prefer the academic session that belongs to the current calendar year.
 * Order: startYear match → endYear match → year in range → isCurrent → most recent.
 */
export const getDefaultApplicationSession = (
	sessions: ApplicationSession[],
	currentYear = new Date().getFullYear(),
): ApplicationSession | null => {
	if (sessions.length === 0) return null;

	const startYearMatch = sessions.find(session => getFullYear(session.startYear) === currentYear);
	if (startYearMatch) return startYearMatch;

	const endYearMatch = sessions.find(session => getFullYear(session.endYear) === currentYear);
	if (endYearMatch) return endYearMatch;

	const inRangeMatch = sessions.find(session => {
		const start = getFullYear(session.startYear);
		const end = getFullYear(session.endYear);
		return start <= currentYear && currentYear <= end;
	});
	if (inRangeMatch) return inRangeMatch;

	const currentSession = sessions.find(session => session.isCurrent);
	if (currentSession) return currentSession;

	const sortedSessions = [...sessions].sort((a, b) => getFullYear(b.startYear) - getFullYear(a.startYear));
	return sortedSessions[0] ?? null;
};

